var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "share-btns" },
    _vm._l(_vm.shareBtns, function(btn, i) {
      return _c(
        "li",
        { key: i, staticClass: "share-btns__item" },
        [
          _c("BaseSocialShare", {
            staticClass: "share-btns__link",
            attrs: { customClass: btn },
            on: { shareLink: _vm.onLinkShare }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08ae9306", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ae9306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/SocialBtnsList.vue
// module id = cota
// module chunks = 0 1 2 3 5 6